import React from 'react';
import '../scss/components/_backendheader.scss'; // Import the CSS file

export default function BackendHeader() {
  return (
    <div className="backend-header"></div> // Empty div, animation is handled with CSS
  );
}
